import { Directive, TemplateRef, ViewContainerRef, effect, inject } from "@angular/core";

import { BetaAccessService } from "./beta-access.service";

/**
 * `*ffLisBeta`: renders its template only for LIS beta users, and adds or removes it when the
 * signed-in user changes. Absent rather than disabled, so a farmer outside the beta never sees a
 * LIS control they cannot use.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector -- `*ffLisBeta` is the approved beta wall name (FLO-679 plan, section 5)
  selector: "[ffLisBeta]",
  standalone: true,
})
export class LisBetaDirective {
  private readonly template = inject(TemplateRef<unknown>);
  private readonly container = inject(ViewContainerRef);
  private readonly beta = inject(BetaAccessService);
  private shown = false;

  constructor() {
    effect(() => {
      const beta = this.beta.lisBeta();
      if (beta && !this.shown) {
        this.container.createEmbeddedView(this.template);
        this.shown = true;
      } else if (!beta && this.shown) {
        this.container.clear();
        this.shown = false;
      }
    });
  }
}
